import React from "react";
import { Pagination as BsPagination } from "react-bootstrap";

class Pagination extends React.Component {
  constructor(props) {
    super(props);
    this._page = 1;
    this._rows = 10;
    // bind event listeners to this
    this.onChange = this.onChange.bind(this);
  }

  get page() {
    if (!isNaN(this.props.page)) return this.props.page;
    return this._page;
  }

  get rows() {
    if (!isNaN(this.props.rows)) return this.props.rows;
    return this._rows;
  }

  onChange(e) {
    if (this.props.disabled || !e || !e.target) return;
    e.preventDefault();
    let page;
    if (e.target.dataset && e.target.dataset.page) {
      page = e.target.dataset.page;
    } else if (e.target.parentNode && e.target.parentNode.dataset) {
      page = e.target.parentNode.dataset.page;
    }
    if (!page) return;
    // TODO update own local variables that are changed if no props are provided
    if (typeof this.props.onChange !== "function") return;
    this.props.onChange({ page: Number(page) });
  }

  searchListe(item, search) {
    if (typeof this.props.searchListe === "function") {
      return this.props.searchListe(item, search);
    }
    return true;
  }

  getLimits(length) {
    if (length <= this.rows) return { start: length ? 1 : 0, end: length };
    let start = 1 + (this.page - 1) * this.rows;
    let end = start + this.rows - 1;
    if (end > length) end = length;
    return ({ start, end });
  }

  getPagination(liste) {
    if (!liste || liste.length <= this.rows) return null;
    let items = [];
    let active = this.page;
    let pages = Math.ceil(liste.length / this.rows);
    let start = 1, end = pages;
    if (pages > 10) {
      items.push(<BsPagination.First
        key="first"
        title="Zur ersten Seite"
        data-page={1}
        onClick={this.onChange}
      />);
      items.push(
        <BsPagination.Prev
          key="prev"
          title="Zur vorherigen Seite"
          data-page={active > 1 ? active - 1 : null}
          onClick={this.onChange}
        />
      );
      if (active > 3) {
        items.push(<BsPagination.Ellipsis key="s1" />);
        start = active - 2;
        if (active < pages - 3) {
          end = active + 2;
        } else {
          start = pages - 4;
        }
      } else {
        end = 5;
      }
    }
    for (let number = start; number <= end; number++) {
      items.push(
        <BsPagination.Item
          key={number}
          title={`Zur Seite ${number} von ${pages}`}
          active={number === active}
          data-page={number}
          onClick={this.onChange}
        >
          {number}
        </BsPagination.Item>,
      );
    }
    if (pages > 10) {
      if (active < pages - 3) items.push(<BsPagination.Ellipsis key="s2" />);
      items.push(
        <BsPagination.Next
          key="next"
          title="Zur nächsten Seite"
          data-page={active < pages ? active + 1 : null}
          onClick={this.onChange}
        />
      );
      items.push(<BsPagination.Last
        key="last"
        title="Zur letzten Seite"
        data-page={pages}
        onClick={this.onChange}
      />);
    }
    return items;
  }

  render() {
    const data = Array.isArray(this.props.list) ? this.props.list : [];
    const paginationItems = this.getPagination(data.filter(item => this.searchListe(item, this.props.search)));
    const { start, end } = this.getLimits(data.length);
    return (
      <>
        <BsPagination>
          {paginationItems}
        </BsPagination>
        {this.props.children
          ? <div className="d-flex">
            {this.props.children}
            <div> {start}-{end} von {data.length}</div>
          </div>
          : null
        }
      </>
    );
  }
}

export default Pagination;
